import { useState } from "react";
import { http, formatErr } from "../lib/api";
import { MailWarning } from "lucide-react";

export function EmailVerifyNotice({ email }) {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const resend = async () => {
    setBusy(true); setMsg(null);
    try {
      const { data } = await http.post("/crm/me/agent/resend-verification");
      if (data.already_verified) setMsg({ ok: true, t: "La tua email risulta già verificata: ricarica la pagina." });
      else if (data.delivered) setMsg({ ok: true, t: `Email di verifica inviata a ${email}. Apri il link ricevuto, poi ricarica questa pagina.` });
      else setMsg({ ok: false, t: "Invio non riuscito: il servizio email non è al momento disponibile. Riprova più tardi o contatta l'amministratore." });
    } catch (e) { setMsg({ ok: false, t: formatErr(e) }); }
    setBusy(false);
  };
  return (
    <div className="mt-3 p-3 rounded-md text-sm" style={{ background: "#fff1f2" }} data-testid="email-verify-notice">
      <div className="flex items-center gap-2 text-rose-700 font-medium"><MailWarning className="w-4 h-4" /> Email non verificata</div>
      <p className="text-xs text-neutral-600 mt-1">Senza verifica dell'email ({email}) non puoi inviare la candidatura.</p>
      <button onClick={resend} disabled={busy} data-testid="email-verify-resend" className="mt-2 px-3 py-1.5 rounded-md border text-xs disabled:opacity-50" style={{ borderColor: "#e11d48", color: "#be123c" }}>{busy ? "Invio…" : "Reinvia email di verifica"}</button>
      {msg && <p className={`text-xs mt-2 ${msg.ok ? "text-green-700" : "text-rose-700"}`} data-testid="email-verify-result">{msg.t}</p>}
    </div>
  );
}
